import { RemoteServiceTaxationCodeAdmin } from "../../../../data/usecases/service-taxation-code/remote-service-taxation-code-admin";
import { ServiceTaxationCodeAdmin } from "../../../../domain/models/service-taxation-code";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteServiceTaxationCodeAdmin = (): ServiceTaxationCodeAdmin =>
  new RemoteServiceTaxationCodeAdmin("/admin/service-taxation-code", makeAxiosHttpClient());
